// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wave {
  /* size */
  width: 100%;
  height: 67px;

  /* children position */
  display: flex;
  padding-top: 5px;
  padding-bottom: 35px;

  box-sizing: content-box;
}

.wave > .nav-bar {
  display: flex;
  justify-content: space-evenly;
  width: 50%;
}

.wave .nav-link {
  margin: 20px 0px;
  height: 40px;

  font-family: "Amatic SC";
  font-size: 22pt;
}

.footer {
  max-width: 100%;
  color: white;

  display: flex;
  flex-direction: column;
  align-items: center;
}

.copyright {
  width: 600px;
  padding-right: 40px;
}

.pattern {
  position: relative;
  top: 20px;
}

.pattern img {
  max-width: 100%;
}
`, "",{"version":3,"sources":["webpack://./src/Components/Waves.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,WAAW;EACX,YAAY;;EAEZ,sBAAsB;EACtB,aAAa;EACb,gBAAgB;EAChB,oBAAoB;;EAEpB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,YAAY;;EAEZ,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,YAAY;;EAEZ,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,eAAe;AACjB","sourcesContent":[".wave {\n  /* size */\n  width: 100%;\n  height: 67px;\n\n  /* children position */\n  display: flex;\n  padding-top: 5px;\n  padding-bottom: 35px;\n\n  box-sizing: content-box;\n}\n\n.wave > .nav-bar {\n  display: flex;\n  justify-content: space-evenly;\n  width: 50%;\n}\n\n.wave .nav-link {\n  margin: 20px 0px;\n  height: 40px;\n\n  font-family: \"Amatic SC\";\n  font-size: 22pt;\n}\n\n.footer {\n  max-width: 100%;\n  color: white;\n\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.copyright {\n  width: 600px;\n  padding-right: 40px;\n}\n\n.pattern {\n  position: relative;\n  top: 20px;\n}\n\n.pattern img {\n  max-width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
